import { AmplitudeFlagKey, TicketingFormCategory } from "@simplyk/common";

import { useRateContext } from "../Context/RateContext";

import { trpc } from "@/common/helpers/trpc";
import { useAmplitudeFeatureFlag } from "@/common/hooks/amplitude/useAmplitudeFeatureFlag";
import { useStableLiveFormEditorContext } from "@/features/LiveFormEditor/common/LiveFormEditorContext";

export const useRateRenewalPrices = () => {
  const { rateId, formCategory } = useRateContext();
  const { apiFormObject: ticketing } = useStableLiveFormEditorContext<"ticketing">();

  const isMembership = formCategory === TicketingFormCategory.MembershipV2;
  const { isActive, loading: isFlagLoading } = useAmplitudeFeatureFlag({
    flagKey: AmplitudeFlagKey.MembershipCampaignReplacement,
    organizationId: ticketing.organizationId ?? undefined,
    skip: !isMembership,
  });

  const { data: renewalPrices, isLoading: isRenewalPricesLoading } = trpc.getMembershipRenewalPrices.useQuery(
    { ticketingId: ticketing.id },
    { enabled: Boolean(isMembership && isActive && ticketing.id) }
  );

  return {
    lastPaidPrices: renewalPrices?.find((renewalPrice) => renewalPrice.rateId === rateId)?.lastPaidPrices ?? [],
    isLoading: isMembership && (isFlagLoading || isRenewalPricesLoading),
  };
};
